import React, { Component }         from 'react';

class OneButton extends Component {
    constructor(props) {
        super(props);
        this.addPhotoChange = this.addPhotoChange.bind(this);
    }

    addPhotoChange() {
        this.props.onChange(this.props.message, this.props.position)
    }

    render(){
        return (
                <div>
                    {
                        (()=>{
                            switch (this.props.message.type){
                                case 'one_button':
                                    return(
                                        <div id={this.props.id} className="message-button input-root" onClick={()=>{this.props.onClick(this.props.message)}}>
                                            {this.props.message.text}
                                        </div>
                                    );
                                case 'one_button_phone':
                                    return(
                                        <div id={this.props.id} className="message-button message-button-phone input-root">
                                            <a href={'tel:'+this.props.message.phone}>
                                                {this.props.message.text}
                                            </a>
                                        </div>
                                    );

                                case 'add_photo_button':
                                    return (

                                      <div id='upload-btn-wrapper'>
                                          <button className={this.props.chatBotType === 'watch' ? 'upload-btn orange message-button' : 'upload-btn'}>
                                              <input type='file'
                                                     onChange={this.addPhotoChange}
                                                     accept={this.props.accept}/>
                                          </button>
                                      </div>
                                    )
                            }
                        })()
                    }
                </div>

        );
    }
}

export default OneButton;